export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-purple-50/20 to-pink-50/20 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl p-8 md:p-12">
        <h1 className="text-4xl font-bold text-textDark mb-8">นโยบายความเป็นส่วนตัว</h1>
        
        <div className="space-y-6 text-textDark">
          <section>
            <p className="text-textLight leading-relaxed">
              EduMi ให้ความสำคัญกับความเป็นส่วนตัวของคุณ นโยบายความเป็นส่วนตัวนี้อธิบายว่าเราเก็บรวบรวม 
              ใช้งาน และปกป้องข้อมูลส่วนบุคคลของคุณอย่างไร
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">1. ข้อมูลที่เราเก็บรวบรวม</h2>
            <p className="text-textLight leading-relaxed mb-3">
              เราอาจเก็บรวบรวมข้อมูลประเภทต่อไปนี้:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li><strong>ข้อมูลส่วนบุคคล:</strong> ชื่อ, อีเมล, เบอร์โทรศัพท์, ที่อยู่</li>
              <li><strong>ข้อมูลบัญชี:</strong> ชื่อผู้ใช้, รหัสผ่าน (เข้ารหัส), รูปโปรไฟล์</li>
              <li><strong>ข้อมูลการชำระเงิน:</strong> ข้อมูลบัตรเครดิต/เดบิต (ผ่าน payment gateway ที่ปลอดภัย)</li>
              <li><strong>ข้อมูลการใช้งาน:</strong> IP address, browser type, หน้าที่เข้าชม, เวลาที่ใช้งาน</li>
              <li><strong>ข้อมูลคอร์ส:</strong> คอร์สที่สร้าง, เนื้อหาที่อัปโหลด, ความคืบหน้าการเรียน</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">2. วิธีการเก็บรวบรวมข้อมูล</h2>
            <p className="text-textLight leading-relaxed mb-3">
              เราเก็บรวบรวมข้อมูลผ่านวิธีต่อไปนี้:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li>ข้อมูลที่คุณให้โดยตรงเมื่อสมัครสมาชิกหรือใช้งานบริการ</li>
              <li>ข้อมูลที่เก็บอัตโนมัติผ่าน cookies และเทคโนโลยีที่คล้ายกัน</li>
              <li>ข้อมูลจากบุคคลที่สาม เช่น Google, Facebook (หากคุณเลือกเข้าสู่ระบบผ่านบริการเหล่านี้)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">3. การใช้ข้อมูลของคุณ</h2>
            <p className="text-textLight leading-relaxed mb-3">
              เราใช้ข้อมูลของคุณเพื่อวัตถุประสงค์ต่อไปนี้:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li>ให้บริการและดำเนินการตามคำขอของคุณ</li>
              <li>ปรับปรุงและพัฒนาแพลตฟอร์มของเรา</li>
              <li>ส่งการแจ้งเตือนและข้อมูลที่เกี่ยวข้องกับบริการ</li>
              <li>ประมวลผลการชำระเงินและจัดการบัญชีของคุณ</li>
              <li>วิเคราะห์การใช้งานเพื่อปรับปรุงประสบการณ์ผู้ใช้</li>
              <li>ป้องกันการฉ้อโกงและรักษาความปลอดภัย</li>
              <li>ปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้อง</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. การแบ่งปันข้อมูล</h2>
            <p className="text-textLight leading-relaxed mb-3">
              เราจะไม่ขาย เช่า หรือแบ่งปันข้อมูลส่วนบุคคลของคุณกับบุคคลที่สาม ยกเว้น:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li><strong>ผู้ให้บริการ:</strong> บริษัทที่ช่วยเราดำเนินธุรกิจ (เช่น payment gateway, hosting)</li>
              <li><strong>ตามกฎหมาย:</strong> เมื่อกฎหมายกำหนดหรือเพื่อปกป้องสิทธิ์ของเรา</li>
              <li><strong>การควบรวมกิจการ:</strong> ในกรณีที่มีการควบรวม ขาย หรือโอนธุรกิจ</li>
              <li><strong>ด้วยความยินยอม:</strong> เมื่อคุณให้ความยินยอมอย่างชัดเจน</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">5. ความปลอดภัยของข้อมูล</h2>
            <p className="text-textLight leading-relaxed">
              เราใช้มาตรการรักษาความปลอดภัยที่เหมาะสมเพื่อปกป้องข้อมูลของคุณ รวมถึง:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight mt-3">
              <li>การเข้ารหัสข้อมูล (SSL/TLS)</li>
              <li>การควบคุมการเข้าถึงข้อมูลอย่างเข้มงวด</li>
              <li>การสำรองข้อมูลเป็นประจำ</li>
              <li>การตรวจสอบและอัปเดตระบบความปลอดภัยอย่างสม่ำเสมอ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">6. สิทธิ์ของคุณ</h2>
            <p className="text-textLight leading-relaxed mb-3">
              คุณมีสิทธิ์ต่อไปนี้เกี่ยวกับข้อมูลส่วนบุคคลของคุณ:
            </p>
            <ul className="list-disc list-inside space-y-2 text-textLight">
              <li><strong>สิทธิ์เข้าถึง:</strong> ขอดูข้อมูลส่วนบุคคลที่เราเก็บรักษา</li>
              <li><strong>สิทธิ์แก้ไข:</strong> ขอแก้ไขข้อมูลที่ไม่ถูกต้องหรือไม่สมบูรณ์</li>
              <li><strong>สิทธิ์ลบ:</strong> ขอลบข้อมูลส่วนบุคคลของคุณ</li>
              <li><strong>สิทธิ์คัดค้าน:</strong> คัดค้านการประมวลผลข้อมูลของคุณ</li>
              <li><strong>สิทธิ์โอนย้าย:</strong> ขอรับข้อมูลของคุณในรูปแบบที่สามารถอ่านได้</li>
              <li><strong>สิทธิ์ถอนความยินยอม:</strong> ถอนความยินยอมที่เคยให้ไว้ได้ทุกเมื่อ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. Cookies และเทคโนโลยีติดตาม</h2>
            <p className="text-textLight leading-relaxed">
              เราใช้ cookies และเทคโนโลยีที่คล้ายกันเพื่อปรับปรุงประสบการณ์การใช้งานของคุณ 
              คุณสามารถตั้งค่าเบราว์เซอร์เพื่อปฏิเสธ cookies ได้ แต่อาจส่งผลต่อการใช้งานบางฟีเจอร์
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">8. การเก็บรักษาข้อมูล</h2>
            <p className="text-textLight leading-relaxed">
              เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณตามระยะเวลาที่จำเป็นเพื่อให้บริการ 
              หรือตามที่กฎหมายกำหนด หลังจากนั้นเราจะลบหรือทำให้ข้อมูลไม่สามารถระบุตัวตนได้
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">9. การโอนข้อมูลข้ามประเทศ</h2>
            <p className="text-textLight leading-relaxed">
              ข้อมูลของคุณอาจถูกโอนและเก็บรักษาในเซิร์ฟเวอร์ที่ตั้งอยู่นอกประเทศไทย 
              เราจะดำเนินการให้แน่ใจว่าข้อมูลของคุณได้รับการปกป้องตามมาตรฐานสากล
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">10. ความเป็นส่วนตัวของเด็ก</h2>
            <p className="text-textLight leading-relaxed">
              บริการของเราไม่ได้มุ่งเป้าไปที่เด็กอายุต่ำกว่า 13 ปี 
              เราไม่เก็บรวบรวมข้อมูลส่วนบุคคลจากเด็กโดยเจตนา 
              หากคุณเชื่อว่าเราได้เก็บข้อมูลจากเด็ก กรุณาติดต่อเราทันที
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">11. การเปลี่ยนแปลงนโยบาย</h2>
            <p className="text-textLight leading-relaxed">
              เราอาจปรับปรุงนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว 
              การเปลี่ยนแปลงที่สำคัญจะแจ้งให้คุณทราบผ่านอีเมลหรือประกาศบนเว็บไซต์ 
              เราแนะนำให้คุณตรวจสอบนโยบายนี้เป็นประจำ
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">12. ติดต่อเรา</h2>
            <p className="text-textLight leading-relaxed mb-3">
              หากคุณมีคำถามหรือข้อกังวลเกี่ยวกับนโยบายความเป็นส่วนตัว หรือต้องการใช้สิทธิ์ของคุณ 
              กรุณาติดต่อเราที่:
            </p>
            <ul className="list-none space-y-2 text-textLight">
              <li>📧 อีเมล: privacy@edumi.co</li>
              <li>📱 โทร: 02-XXX-XXXX</li>
              <li>🏢 ที่อยู่: กรุงเทพมหานคร ประเทศไทย</li>
            </ul>
          </section>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-textLight">
              อัปเดตล่าสุด: 14 ธันวาคม 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
